//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class TradingClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getDeposit(depositId: string): Promise<GetDeposit_Response> {
        let url_ = this.baseUrl + "/api/trading/deposit/{DepositId}";
        if (depositId === undefined || depositId === null)
            throw new Error("The parameter 'depositId' must be defined.");
        url_ = url_.replace("{DepositId}", encodeURIComponent("" + depositId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeposit(_response);
        });
    }

    protected processGetDeposit(response: Response): Promise<GetDeposit_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeposit_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDeposit_Response>(null as any);
    }

    /**
     * @return Success
     */
    getDepositOrder(depositId: string, orderId: string): Promise<GetDepositOrder_Response> {
        let url_ = this.baseUrl + "/api/trading/deposit/{DepositId}/order/{OrderId}";
        if (depositId === undefined || depositId === null)
            throw new Error("The parameter 'depositId' must be defined.");
        url_ = url_.replace("{DepositId}", encodeURIComponent("" + depositId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{OrderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDepositOrder(_response);
        });
    }

    protected processGetDepositOrder(response: Response): Promise<GetDepositOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDepositOrder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDepositOrder_Response>(null as any);
    }

    /**
     * @return Success
     */
    getRebalance(rebalanceId: string): Promise<GetRebalance_Response> {
        let url_ = this.baseUrl + "/api/trading/rebalance/{RebalanceId}";
        if (rebalanceId === undefined || rebalanceId === null)
            throw new Error("The parameter 'rebalanceId' must be defined.");
        url_ = url_.replace("{RebalanceId}", encodeURIComponent("" + rebalanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRebalance(_response);
        });
    }

    protected processGetRebalance(response: Response): Promise<GetRebalance_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRebalance_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRebalance_Response>(null as any);
    }

    /**
     * @return Success
     */
    getRebalanceOrder(rebalanceId: string, orderId: string): Promise<GetRebalanceOrder_Response> {
        let url_ = this.baseUrl + "/api/trading/rebalance/{RebalanceId}/order/{OrderId}";
        if (rebalanceId === undefined || rebalanceId === null)
            throw new Error("The parameter 'rebalanceId' must be defined.");
        url_ = url_.replace("{RebalanceId}", encodeURIComponent("" + rebalanceId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{OrderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRebalanceOrder(_response);
        });
    }

    protected processGetRebalanceOrder(response: Response): Promise<GetRebalanceOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRebalanceOrder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRebalanceOrder_Response>(null as any);
    }

    /**
     * @return Success
     */
    getWithdrawal(withdrawalId: string): Promise<GetWithdrawal_Response> {
        let url_ = this.baseUrl + "/api/trading/withdrawal/{WithdrawalId}";
        if (withdrawalId === undefined || withdrawalId === null)
            throw new Error("The parameter 'withdrawalId' must be defined.");
        url_ = url_.replace("{WithdrawalId}", encodeURIComponent("" + withdrawalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithdrawal(_response);
        });
    }

    protected processGetWithdrawal(response: Response): Promise<GetWithdrawal_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawal_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWithdrawal_Response>(null as any);
    }

    /**
     * @return Success
     */
    getWithdrawalOrder(withdrawalId: string, orderId: string): Promise<GetWithdrawalOrder_Response> {
        let url_ = this.baseUrl + "/api/trading/withdrawal/{WithdrawalId}/order/{OrderId}";
        if (withdrawalId === undefined || withdrawalId === null)
            throw new Error("The parameter 'withdrawalId' must be defined.");
        url_ = url_.replace("{WithdrawalId}", encodeURIComponent("" + withdrawalId));
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{OrderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithdrawalOrder(_response);
        });
    }

    protected processGetWithdrawalOrder(response: Response): Promise<GetWithdrawalOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWithdrawalOrder_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = FastEndpointsErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetWithdrawalOrder_Response>(null as any);
    }

    /**
     * Pings the trading service to avoid long cold starts
     * @return Success
     */
    warmup(): Promise<any> {
        let url_ = this.baseUrl + "/api/trading/warmup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWarmup(_response);
        });
    }

    protected processWarmup(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class GetDeposit_Response implements IGetDeposit_Response {
    settledOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;

    constructor(data?: IGetDeposit_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settledOn = _data["settledOn"] ? new Date(_data["settledOn"].toString()) : <any>undefined;
            this.investedOn = _data["investedOn"] ? new Date(_data["investedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["buyIds"])) {
                this.buyIds = [] as any;
                for (let item of _data["buyIds"])
                    this.buyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDeposit_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeposit_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settledOn"] = this.settledOn ? this.settledOn.toISOString() : <any>undefined;
        data["investedOn"] = this.investedOn ? this.investedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.buyIds)) {
            data["buyIds"] = [];
            for (let item of this.buyIds)
                data["buyIds"].push(item);
        }
        return data;
    }
}

export interface IGetDeposit_Response {
    settledOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;
}

/** the dto used to send an error response to the client */
export class FastEndpointsErrorResponse implements IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IFastEndpointsErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): FastEndpointsErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FastEndpointsErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IFastEndpointsErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

export class GetDeposit_Request implements IGetDeposit_Request {

    constructor(data?: IGetDeposit_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDeposit_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeposit_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDeposit_Request {
}

export class GetDepositOrder_Response implements IGetDepositOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;

    constructor(data?: IGetDepositOrder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.dateInvested = _data["dateInvested"] ? new Date(_data["dateInvested"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.dealType = _data["dealType"];
            this.unitQuantity = _data["unitQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.consideration = _data["consideration"];
        }
    }

    static fromJS(data: any): GetDepositOrder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositOrder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["dateInvested"] = this.dateInvested ? this.dateInvested.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["dealType"] = this.dealType;
        data["unitQuantity"] = this.unitQuantity;
        data["unitPrice"] = this.unitPrice;
        data["consideration"] = this.consideration;
        return data;
    }
}

export interface IGetDepositOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;
}

export class GetDepositOrder_Request implements IGetDepositOrder_Request {

    constructor(data?: IGetDepositOrder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetDepositOrder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositOrder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetDepositOrder_Request {
}

export class GetRebalance_Response implements IGetRebalance_Response {
    deInvestedOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;
    sellIds?: string[] | undefined;
    previousAllocation?: GetRebalance_AllocationResponse[] | undefined;
    newAllocation?: GetRebalance_AllocationResponse[] | undefined;

    constructor(data?: IGetRebalance_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deInvestedOn = _data["deInvestedOn"] ? new Date(_data["deInvestedOn"].toString()) : <any>undefined;
            this.investedOn = _data["investedOn"] ? new Date(_data["investedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["buyIds"])) {
                this.buyIds = [] as any;
                for (let item of _data["buyIds"])
                    this.buyIds!.push(item);
            }
            if (Array.isArray(_data["sellIds"])) {
                this.sellIds = [] as any;
                for (let item of _data["sellIds"])
                    this.sellIds!.push(item);
            }
            if (Array.isArray(_data["previousAllocation"])) {
                this.previousAllocation = [] as any;
                for (let item of _data["previousAllocation"])
                    this.previousAllocation!.push(GetRebalance_AllocationResponse.fromJS(item));
            }
            if (Array.isArray(_data["newAllocation"])) {
                this.newAllocation = [] as any;
                for (let item of _data["newAllocation"])
                    this.newAllocation!.push(GetRebalance_AllocationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRebalance_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalance_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deInvestedOn"] = this.deInvestedOn ? this.deInvestedOn.toISOString() : <any>undefined;
        data["investedOn"] = this.investedOn ? this.investedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.buyIds)) {
            data["buyIds"] = [];
            for (let item of this.buyIds)
                data["buyIds"].push(item);
        }
        if (Array.isArray(this.sellIds)) {
            data["sellIds"] = [];
            for (let item of this.sellIds)
                data["sellIds"].push(item);
        }
        if (Array.isArray(this.previousAllocation)) {
            data["previousAllocation"] = [];
            for (let item of this.previousAllocation)
                data["previousAllocation"].push(item.toJSON());
        }
        if (Array.isArray(this.newAllocation)) {
            data["newAllocation"] = [];
            for (let item of this.newAllocation)
                data["newAllocation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRebalance_Response {
    deInvestedOn?: Date | undefined;
    investedOn?: Date | undefined;
    buyIds?: string[] | undefined;
    sellIds?: string[] | undefined;
    previousAllocation?: GetRebalance_AllocationResponse[] | undefined;
    newAllocation?: GetRebalance_AllocationResponse[] | undefined;
}

export class GetRebalance_AllocationResponse implements IGetRebalance_AllocationResponse {
    isin?: string | undefined;
    percentage?: number;

    constructor(data?: IGetRebalance_AllocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): GetRebalance_AllocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalance_AllocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IGetRebalance_AllocationResponse {
    isin?: string | undefined;
    percentage?: number;
}

export class GetRebalance_Request implements IGetRebalance_Request {

    constructor(data?: IGetRebalance_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRebalance_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalance_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRebalance_Request {
}

export class GetRebalanceOrder_Response implements IGetRebalanceOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;

    constructor(data?: IGetRebalanceOrder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.dateInvested = _data["dateInvested"] ? new Date(_data["dateInvested"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.dealType = _data["dealType"];
            this.unitQuantity = _data["unitQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.consideration = _data["consideration"];
        }
    }

    static fromJS(data: any): GetRebalanceOrder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalanceOrder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["dateInvested"] = this.dateInvested ? this.dateInvested.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["dealType"] = this.dealType;
        data["unitQuantity"] = this.unitQuantity;
        data["unitPrice"] = this.unitPrice;
        data["consideration"] = this.consideration;
        return data;
    }
}

export interface IGetRebalanceOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;
}

export class GetRebalanceOrder_Request implements IGetRebalanceOrder_Request {

    constructor(data?: IGetRebalanceOrder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRebalanceOrder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetRebalanceOrder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRebalanceOrder_Request {
}

export class GetWithdrawal_Response implements IGetWithdrawal_Response {
    deInvestedOn?: Date | undefined;
    sellIds?: string[] | undefined;
    settledOn?: Date | undefined;
    finalisedAmount?: number | undefined;

    constructor(data?: IGetWithdrawal_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deInvestedOn = _data["deInvestedOn"] ? new Date(_data["deInvestedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["sellIds"])) {
                this.sellIds = [] as any;
                for (let item of _data["sellIds"])
                    this.sellIds!.push(item);
            }
            this.settledOn = _data["settledOn"] ? new Date(_data["settledOn"].toString()) : <any>undefined;
            this.finalisedAmount = _data["finalisedAmount"];
        }
    }

    static fromJS(data: any): GetWithdrawal_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawal_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deInvestedOn"] = this.deInvestedOn ? this.deInvestedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.sellIds)) {
            data["sellIds"] = [];
            for (let item of this.sellIds)
                data["sellIds"].push(item);
        }
        data["settledOn"] = this.settledOn ? this.settledOn.toISOString() : <any>undefined;
        data["finalisedAmount"] = this.finalisedAmount;
        return data;
    }
}

export interface IGetWithdrawal_Response {
    deInvestedOn?: Date | undefined;
    sellIds?: string[] | undefined;
    settledOn?: Date | undefined;
    finalisedAmount?: number | undefined;
}

export class GetWithdrawal_Request implements IGetWithdrawal_Request {

    constructor(data?: IGetWithdrawal_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWithdrawal_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawal_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWithdrawal_Request {
}

export class GetWithdrawalOrder_Response implements IGetWithdrawalOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;

    constructor(data?: IGetWithdrawalOrder_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isin = _data["isin"];
            this.dateInvested = _data["dateInvested"] ? new Date(_data["dateInvested"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.dealType = _data["dealType"];
            this.unitQuantity = _data["unitQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.consideration = _data["consideration"];
        }
    }

    static fromJS(data: any): GetWithdrawalOrder_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawalOrder_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isin"] = this.isin;
        data["dateInvested"] = this.dateInvested ? this.dateInvested.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["dealType"] = this.dealType;
        data["unitQuantity"] = this.unitQuantity;
        data["unitPrice"] = this.unitPrice;
        data["consideration"] = this.consideration;
        return data;
    }
}

export interface IGetWithdrawalOrder_Response {
    isin?: string | undefined;
    dateInvested?: Date | undefined;
    orderType?: string | undefined;
    dealType?: string | undefined;
    unitQuantity?: number | undefined;
    unitPrice?: number | undefined;
    consideration?: number | undefined;
}

export class GetWithdrawalOrder_Request implements IGetWithdrawalOrder_Request {

    constructor(data?: IGetWithdrawalOrder_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetWithdrawalOrder_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetWithdrawalOrder_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetWithdrawalOrder_Request {
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}